import { useCallback } from 'react';
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

import useDispatchWithUnwrap from 'hooks/useDispatchWithUnwrap';
import { createGoogleAssessment } from 'thunks';

const MIN_VALID_SCORE = 0.5;

export const useGetAndVerifyReCaptchaToken = () => {
  const dispatchWithUnwrap = useDispatchWithUnwrap();
  const { executeRecaptcha } = useGoogleReCaptcha();

  return useCallback(async (action: string) => {
    if (!executeRecaptcha) {
      return;
    }

    const token = await executeRecaptcha(action);

    if (token) {
      const assessment = await dispatchWithUnwrap(createGoogleAssessment({ token, action }));

      const isValidUser = assessment?.isValid;
      const isValidScore = assessment?.score ? assessment.score >= MIN_VALID_SCORE : false;

      return isValidUser && isValidScore;
    }

    return false;
  }, [executeRecaptcha]);
};
